import { computed, Directive, inject, input } from '@angular/core';
import { FloatingPopupService } from '@app/main/main-content/floating-popup-manager/services/floating-popup.service';
import { IFloatingPopupInstance } from '@app/main/main-content/floating-popup-manager/interfaces/floating-popup-instance';

@Directive()
export abstract class FloatingPopupBaseContentComponent {
  public readonly service: FloatingPopupService = inject(FloatingPopupService);

  public popup = input.required<IFloatingPopupInstance>();

  public popupId = computed(() => this.popup().id, { equal: (a, b) => a === b });
}
